export default __webpack_public_path__ + "assets/skrepka_big.png";